#import "@core/schema/fragments/DogFull.graphql"

query (
  $chipNumber: String!
) {
  getDogByChipNumber(
    chipNumber: $chipNumber
  ) {
    ...DogFull
  }
}
